// extracted by mini-css-extract-plugin
export default {"createNewRole":"CreateNewRole_createNewRole__SA-CD","textField":"CreateNewRole_textField__heCjv","btn":"CreateNewRole_btn__Qup8f","errorMessage":"CreateNewRole_errorMessage__2rHFQ"};